import { z } from 'zod';

export const InputSchema = z.object({
    accountId: z.number(),
});

const limitsObject = z.object({
    windowLengthInDays: z.number(),
    activeLimitValue: z.number(),
    pendingLimitValue: z.number().nullable(),
    pendingRequestedAt: z.string().nullable(),
    limitValueMax: z.number().nullable(),
    triggersWarningEmail: z.boolean(),
    lastWarningEmailSentDate: z.string().nullable(),
    sendWarningEmailPauseDurationInDays: z.number().nullable(),
    hardLimit: z.boolean(),
    // skipPendingState: z.boolean(),
    limitType: z.enum(['rolling', 'calendar', 'lifetime']),
    calculationType: z.enum(['gross', 'net']).optional().default('net'),
});

export type LimitsObjectSchemaType = z.infer<typeof limitsObject>;

export const SuccessResponseSchema = z.array(limitsObject);

export type SuccessResponseType = z.infer<typeof SuccessResponseSchema>;

export const ErrorServerResponseSchema = z.object({
    message: z.string(),
    debugDetails: z.string(),
});

export type ErrorServerResponseType = z.infer<typeof ErrorServerResponseSchema>;

export const ErrorServerResponseSecondSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
    }),
});

export type ErrorServerResponseSecondType = z.infer<typeof ErrorServerResponseSecondSchema>;

export type ResponseType =
    | { responseStatus: 'success'; data: SuccessResponseType }
    | {
          responseStatus: 'apiServerError';
          data: ErrorServerResponseType;
      }
    | {
          responseStatus: 'apiServerSecondError';
          data: ErrorServerResponseSecondType;
      }
    | {
          responseStatus: 'apiError';
          status: number;
          data?: unknown;
      };
